<template>
  <footer class="small text-center animated fadeInDown delay-1s mt-4">
    <p class="mb-0 text-secondary">© 2025 PZ ACADEMY. All RIGHT RESERVED.</p>
    <p class="mb-0">
      <a
        class="text-secondary ml-lg-3"
        href="http://www.beian.miit.gov.cn/publish/query/indexFirst.action"
        target="_blank"
        >沪ICP备 15048842号-1</a
      >
    </p>
  </footer>
</template>

<script>
export default {
  name: 'FooterPzId',
  // props: {
  //   msg: String,
  // },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
